export const getSSOLoginUrl = () =>
    new URL(
        `/oauth2/authorization/keycloak?targetUrl=${encodeURIComponent(window.location.href)}`,
        window.origin,
    ).toString()
